<template>
  <div id="basic">
    <div class="top_div_basic" v-loading="listloading">
      <div class="basic_top">
        <div>公司信息</div>
        <div style="color: #1890ff; cursor: pointer;" @click="clickTop()">编辑</div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
          <span>名称:</span>
          <span>{{company.name}}</span>
        </div>
        <div class="basic_value_s">
          <span>地址:</span>
          <span>{{company.province}} {{company.province!==company.city&&company.city||''}} {{company.district}} {{company.address}}</span>
        </div>
        <div class="basic_value_s">
          <span>邀请码:</span>
          <span>{{company.invite_code}}</span>
        </div>
        <div class="basic_value_s">
          <span>创建时间:</span>
          <span>{{company.created_at}}</span>
        </div>
        <div class="basic_value_s">
          <span>更新时间:</span>
          <span>{{company.updated_at}}</span>
        </div>
        <div class="basic_value_s" v-if="company.deleted_at">
          <span>删除时间:</span>
          <span>{{company.deleted_at}}</span>
        </div>
      </div>
    </div>
    <div class="top_div_basic" v-loading="listloading">
      <div class="basic_top">
        <div>用户信息</div>
        <div style="display:flex">
          <div style="color: #1890ff; cursor: pointer;margin-right:20px" @click="clickTopss()">修改密码</div>
          <div style="color: #1890ff; cursor: pointer;" @click="clickTops()">编辑</div>
        </div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
          <span>用户名称:</span>
          <span>{{user.name}}</span>
        </div>

        <div class="basic_value_s">
          <span>联系方式:</span>
          <span>{{user.mobile}}</span>
        </div>
        <div class="basic_value_s">
          <span>性别:</span>
          <span>{{user.gender}}</span>
        </div>
        <div class="basic_value_s">
          <span>头像:</span>
          <img :src="user.avatar" style="width:50px;height:50px;border:solid 1px #000" />
        </div>
        <div class="basic_value_s">
          <span>创建时间:</span>
          <span>{{user.created_at}}</span>
        </div>
        <div class="basic_value_s">
          <span>更新时间:</span>
          <span>{{user.updated_at}}</span>
        </div>
      </div>
    </div>
    <el-dialog title="详细信息" :visible.sync="dialogFormVisible_ca">
      <el-form :model="company">
        <el-form-item label="公司名称" :label-width="formLabelWidth">
          <el-input v-model="company.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="省" :label-width="formLabelWidth">
          <el-input v-model="company.province" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth">
          <el-input v-model="company.city" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="区" :label-width="formLabelWidth">
          <el-input v-model="company.district" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input v-model="company.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_ca=false">取 消</el-button>
        <el-button type="primary" @click="statusStore()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="详细信息" :visible.sync="dialogFormVisible_cas">
      <el-form :model="user">
        <el-form-item label="用户名称" :label-width="formLabelWidth">
          <el-input v-model="user.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth">
          <el-select v-model="user.gender" placeholder="请选择">
            <el-option label="男" :value="'男'"></el-option>
            <el-option label="女" :value="'女'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式" :label-width="formLabelWidth">
          <el-input v-model="user.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="头像" :label-width="formLabelWidth">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <!-- <el-form-item label="avatar" :label-width="formLabelWidth">
          <el-input v-model="user.avatar" autocomplete="off"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_cas=false">取 消</el-button>
        <el-button type="primary" @click="statusStores()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改用户密码" :visible.sync="dialogFormVisible_cass">
      <el-form :model="user">
        <el-form-item label="老密码" prop="pass">
          <el-input
            prefix-icon="el-icon-lock"
            type="password"
            v-model="ruleForm.old_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input
            prefix-icon="el-icon-lock"
            type="password"
            v-model="ruleForm.new_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_cass=false">取 消</el-button>
        <el-button type="primary" @click="statusStoress()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'dailymenu',
  components: {},
  data() {
    return {
      toplis: [],
      company: {},
      toploading: false,
      listloading: false,
      user: {},
      dialogFormVisible_ca: false,
      dialogFormVisible_cas: false,
      dialogFormVisible_cass: false,
      formLabelWidth: '120px',
      ruleForm: {
        old_password: '',
        new_password: '',
      },
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
    };
  },
  methods: {
    statusStore() {
      const url = this.$userList.user_account_company;
      const data = {
        id: this.company.id,
        name: this.company.name,
        province: this.company.province,
        city: this.company.city,
        district: this.company.district,
        address: this.company.address,
      };
      this.$http.put(url, data).then(res => {
        if (res.code === 200) {
          this.getCompany('25867635458561');
          this.dialogFormVisible_ca = false;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    statusStores() {
      const url = this.$userList.user_account_user;
      console.log(this.fileList);
      const data = {
        id: this.user.id,
        name: this.user.name,
        gender: this.user.gender,
        mobile: this.user.mobile,
        avatar: (this.fileList.length>0 && this.fileList[0].url) || '',
      };
      this.$http.put(url, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible_cas = false;
          this.getUser();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    statusStoress() {
      const url = this.$userList.user_account_password;
      const data = {
        new_password: this.$sha256(this.ruleForm.new_password),
        old_password: this.$sha256(this.ruleForm.old_password),
      };
      this.$http.post(url, data).then(res => {
        if (res.code === 200) {
          this.$alert('修改密码成功');
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    clickTop() {
      this.dialogFormVisible_ca = true;
    },
    clickTops() {
      this.fileList = [{ url: this.user.avatar}];
      this.dialogFormVisible_cas = true;
    },
    clickTopss() {
      this.dialogFormVisible_cass = true;
    },
    getUser() {
      const url = this.$userList.user_account_user;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.user = res.data;
          this.fileList = [{url:this.user.avatar}];
          console.log('user', this.user, this.fileList);
          localStorage.setItem('userInfo',JSON.stringify(this.user))
          this.getCompany(res.data.id);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    getCompany(id) {
      const url = this.$userList.user_account_company + '/' + id;

      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.company = res.data;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      console.log(fileList);
      this.fileList = fileList.map(item => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then(res => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
  },
  created() {
    this.getUser();
    this.$root.setheadName();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.top_div_basic {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
}
.basic_top {
  width: 100%;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: solid 1px rgb(160, 160, 160);
}
.basic_value,
.basic_value_s {
  width: 100%;
  height: auto;
}
.basic_value_s {
  margin-top: 20px;
}
.basic_value_s span:nth-child(1) {
  margin-right: 20px;
}
.top_name {
  width: 100%;
  height: auto;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 0;
}
.name_list {
  flex: 1;
  height: 100%;
  border-right: solid 1px rgba(0, 0, 0, 0.5);
  font-size: 20px;
}
.name_color {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  margin-bottom: 10px;
}
.name_color_s {
  color: rgba(0, 0, 0, 1);
  font-size: 30px;
  margin-bottom: 10px;
}
.name_list_s {
  margin: 0 20px;
  display: flex;
  color: rgba(41, 39, 39, 0.952);
  padding-top: 20px;
  font-size: 15px;
  border-top: solid 1px rgba(0, 0, 0, 0.3);
}
.name_list_x {
  margin: 0 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
}
.name_list_s_1 {
  margin-left: 10px;
}
.name_list:last-child {
  border-right: none;
}
.basic_value_img {
  margin-top: 10px;
}
.basic_value_img > img {
  width: 70px;
  height: 70px;
  margin-right: 10px;
  background: rgba(83, 120, 243, 0.3);
}
</style>
